import api from '@/services/apiService';
import { SportCategory, SportCategoriesApiResponse } from '@/types/sportCategory';

class SportCategoryService {
  private cache: Record<string, SportCategory[]> = {};
  private categoryCache: Record<string, SportCategory> = {};

  async getCategoriesForArena(slug: string): Promise<SportCategory[]> {
    if (this.cache[slug]) return this.cache[slug];

    try {
      const res = await api.get(`/arenas/${encodeURIComponent(slug)}/sport-categories`);
      const body: SportCategoriesApiResponse = res.data;
      const cats = body.data || [];
      this.cache[slug] = cats;
      return cats;
    } catch (err) {
      console.error('Failed to load sport categories for', slug, err);
      return [];
    }
  }

  async getCategoryBySlug(slug: string): Promise<SportCategory | null> {
    if (this.categoryCache[slug]) return this.categoryCache[slug];

    try {
      const res = await api.get(`/sport-categories/slug/${encodeURIComponent(slug)}`);
      const body = res.data;
      if (body.success && body.data) {
        this.categoryCache[slug] = body.data;
        return body.data;
      }
      return null;
    } catch (err) {
      console.error('Failed to load sport category:', slug, err);
      return null;
    }
  }
}

export const sportCategoryService = new SportCategoryService();
export default sportCategoryService;
